import type { Styles } from "react-joyride";

/**
 * Joyride tour styles
 *
 * Key considerations:
 * - z-index: 10000+ to ensure overlay appears above all page elements including headers
 * - Spotlight creates a "hole" in the overlay to highlight target elements
 * - Arrow color matches tooltip background for seamless appearance
 */
export const tourStyles: Partial<Styles> = {
  options: {
    primaryColor: "#6366f1",
    textColor: "#1f2937",
    overlayColor: "rgba(0, 0, 0, 0.6)", // Slightly darker for better contrast
    zIndex: 10000, // High z-index to appear above header and other fixed elements
    arrowColor: "#ffffff",
  },
  tooltipContainer: {
    textAlign: "left",
  },
  spotlight: {
    borderRadius: "12px",
    boxShadow: "0 0 0 4px rgba(99, 102, 241, 0.4)", // Indigo glow around spotlight
    backgroundColor: "transparent", // Ensure spotlight shows underlying content
  },
  overlay: {
    mixBlendMode: undefined, // Prevent blend mode issues
  },
  beacon: {
    display: "none",
  },
  // Hide all default buttons - we render our own in custom tooltip
  buttonNext: {
    display: "none",
  },
  buttonBack: {
    display: "none",
  },
  buttonSkip: {
    display: "none",
  },
  buttonClose: {
    display: "none",
  },
};
